/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import _ from 'lodash';


const propTypes = {
  val: React.PropTypes.any,
  formatter: React.PropTypes.func,
};

class LoadingVal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      val: this.props.val,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.val !== this.props.val) {
      this.setState({
        val: nextProps.val,
      });
    }
  }

  render() {
    let { val } = this.state;
    if (_.isNil(val)) {
      return <i className="fa fa-spinner fa-spin" />;
    }
    if (this.props.formatter) {
      val = this.props.formatter(val);
    }
    return <span>{val}</span>;
  }
}

LoadingVal.propTypes = propTypes;

export default LoadingVal;




// WEBPACK FOOTER //
// ./src/components/LoadingVal/index.jsx